<template>
    <form autocomplete="off" v-on:submit.prevent="confirm">

        <p>{{ lang.polaris.settings.confirm_delete_tasks_q }}</p>

        <trax-ui-checkbox v-for="status in statuses" :key="status.value"
            :text="status.name" v-model="form[status.value]">
        </trax-ui-checkbox>

        <!-- Submit buttons -->

        <div class="trax-form-actions text-right">
            <button type="button" class="btn btn-default btn-link" data-dismiss="modal"> {{ lang.polaris.form.cancel }} </button>
            <button type="submit" class="btn btn-danger btn-round" :disabled="!selected.length"> {{ lang.polaris.form.confirm }} </button>
        </div>

    </form>
</template>

<script>
    export default {

        props: {
            id: null,
            bus: null
        },

        data: function() {
            return {
                lang: lang,

                // A running task is stopped with a cancellation, not deleted. A cancelled one is
                // removed on the spot, so it is never here either.
                // Queued last: emptying the queue throws away work which was asked for, so it is
                // the least expected thing to do here.
                statuses: [
                    { name: lang.polaris.tasks.completed, value: 'completed' },
                    { name: lang.polaris.tasks.failed, value: 'failed' },
                    { name: lang.polaris.tasks.pending, value: 'pending' },
                ],
                form: {
                    completed: true,
                    failed: false,
                    pending: false,
                }
            }
        },

        computed: {

            selected() {
                var that = this;
                return Object.keys(this.form).filter(function (status) {
                    return that.form[status];
                });
            }
        },

        methods: {

            confirm() {
                this.bus.$emit(this.id+'-delete-tasks-confirmed', this.selected);
                this.bus.$emit(this.id+'-delete-tasks-close');
            }
        }

    }
</script>
